function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#596168",
  fillRule: "evenodd",
  d: "M9 2a7 7 0 100 14A7 7 0 009 2zm2.5 5c.815 0 1.481.658 1.5 1.482C13 9.32 12.328 10 11.5 10S10 9.32 10 8.482A1.508 1.508 0 0111.5 7zM4 8.5C4.021 7.1 5.14 5.982 6.5 6 7.857 5.99 8.972 7.103 9 8.5c-.025 1.399-1.141 2.515-2.5 2.5-1.359.015-2.475-1.101-2.5-2.5zm0 3.079a3.889 3.889 0 012.215-.576c2.164 0 3.255 1.294 3.785 2.876a6.312 6.312 0 01-1.262.12C6.812 14 5.023 13.067 4 11.58zm6.755 2.39a6.206 6.206 0 00-.751-1.474A4.647 4.647 0 009 11.41c.533-.908 1.567-1.453 2.668-1.407a3.021 3.021 0 012.332.95c-.594 1.39-1.766 2.491-3.245 3.047v-.03z"
});

var SvgPeople = function SvgPeople(props) {
  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _ref);
};

export default SvgPeople;